import { ICellRendererParams } from 'ag-grid-community'

import { Alert } from '@/gen/inventory/v1/alert_pb'

import { useHasPermissions } from '@/lib/app/check-permissions.hook'

import { EmptyCellValue } from '@/components/ag-cells/empty-cell-value'
import { SelectAlertStatusBadge } from '@/components/shared/select-alert-status-badge/select-alert-status-badge'

interface AlertStatusCellParams extends ICellRendererParams<Alert> {
  readOnly?: boolean
}

export const AlertStatusCell = ({ data, readOnly }: AlertStatusCellParams) => {
  const hasManagePermissions = useHasPermissions(['base.manage'])

  if (!data) {
    return <EmptyCellValue />
  }

  return (
    <SelectAlertStatusBadge
      alertId={data.id}
      status={data.workStatus}
      extraTrackingProps={{
        from: 'alert-table',
        signalTitle: data.signal?.title,
      }}
      readOnly={readOnly || !hasManagePermissions}
    />
  )
}
